<template>
  <section id="trucks">
    <main style="text-align:left;white-space:normal">

      <!-- * Title -->
      <div class="title">
        <icon icoClass='title-ico' selected='trucks'/> {{$t('trucks')}}
        <a @click="openTruckDetail()" class="btn-blue btn-small" v-if="canAddTruck">{{$t("add_truck")}}</a>
      </div>

      <!-- * Filters -->
      <div id="filters">
        <div v-if="canSeeFilters">
          <div class="field">
            <label>{{$t("from")}}</label>
            <input type="date" v-model="filters.register_date_after" @change="fillPage(1)"/>
          </div>
          <div class="field">
            <label>{{$t("to")}}</label>
            <input type="date" v-model="filters.register_date_before" @change="fillPage(1)">
          </div>
          <div class="field">
            <label>{{$t("name")}}</label>
            <input type="text" v-model="filters.name" @keyup.enter="fillPage(1)" @change="fillPage(1)">
          </div>
          <div class="field">
            <label>{{$t("plate")}}</label>
            <input type="text" v-model="filters.plate" @keyup.enter="fillPage(1)" @change="fillPage(1)">
          </div>
        </div>
        <date-filter
          @update="$set(filters,'register_date_before',$event.before); $set(filters,'register_date_after',$event.after); fillPage(1)"
          :before="filters.register_date_before"
          :after="filters.register_date_after"
          :options="['yesterday', 'today', 'tomorrow']"
          @reset="filters={}; fillPage(1)"
        />
      </div>

      <!-- * Loader -->
      <load-screen :notFullScreen="true" v-show="loadingList"></load-screen>

      <!-- * Table -->
      <table v-show="!loadingList" class="custom-table">
        <thead>
          <th>{{$t('name')}}</th>
          <th>{{$t('plate')}}</th>
          <th v-if="hasSms">{{$t('phone')}}</th>
          <th>{{$t('ar_hour')}}</th>
          <th>{{$t('dp_hour')}}</th>
          <th v-if="canEditTruck">{{$t('detail')}}</th>
          <th v-if="canEditTruck">{{$t('delete')}}</th>
        </thead>
        <tbody>
          <tr v-for="(truck, index) in objects" :key="index">
            <td>{{truck.name}}</td>
            <td>{{truck.plate}}</td>
            <td v-if="hasSms">{{truck.phone}}</td>
            <td>{{truck.register_date | moment('DD/MM/YYYY HH:mm')}}</td>
            <td>{{truck.expedition_date | moment('DD/MM/YYYY HH:mm')}}</td>
            <td v-if="canEditTruck" style="padding:0; font-size:1.5em">
              <a :title="$t('edit')" @click="openTruckDetail(truck)">
                <misc-icon icoClass='title-ico' selected='edit'/>
              </a>
            </td>
            <td style="padding:0; font-size:1.5em; color: #DD3355; cursor: pointer" v-if="canEditTruck">
              <i class="fa fa-times" @click="line=truck; showDelete=true" />
            </td>
          </tr>
        </tbody>
      </table>

      <!-- * Pagination -->
      <div id="pages">
        <div class="move-page" @click="page > 1 ? fillPage(page-1) : ''">«{{$t('prev')}}.</div>
        <div v-for="pageShown in pagesShown" :key="pageShown" :class="page===pageShown? 'selected-page': 'page'" @click="fillPage(pageShown)">
          {{pageShown}}
        </div>
        <div class="move-page" @click="page < count/pageSize ? fillPage(page+1) : ''">{{$t('next')}}.»</div>
      </div>
    </main>

    <!-- * Modals -->
    <modal v-show="showDelete">
      <div slot="body" class="delete-modal">
        {{$t('delete_message_truck')}}
        <div class="buttons">
          <button class="btn-green" @click="deleteLine(line)">{{$t('ok')}}</button>
          <button class="btn-black" @click="showDelete=false;line=[];">{{$t('cancel')}}</button>
        </div>
      </div>
    </modal>
    <modal v-if="showTruckDetail">
      <div slot="body">
        <add-truck :id="truckId" @cancel="showTruckDetail=false; truckId=null" @save="handleTruckSave" />
      </div>
    </modal>
  </section>
</template>

<script>
import PaginatedFilteredListMixin from '@/pages/mixins/PaginatedFilteredListMixin'
import DateFilter from './../components/DateFilter'
import LoadScreen from './../components/LoadScreen'
import AddTruck from './../components/Truck'
import {mapActions, mapState} from 'vuex'
import Modal from './../components/Modal'
import miscIcon from './../svg/misc'
import icon from './../svg/tabs'
export default {
  name: 'trucks',
  components: {
    DateFilter,
    LoadScreen,
    miscIcon,
    AddTruck,
    Modal,
    icon
  },
  props: {},
  mixins: [PaginatedFilteredListMixin],
  created () {
    this.$emit('loading')
  },
  mounted () {
    this.refreshTable()
    this.getTrucksData()
  },
  data () {
    return {
      hasSms: process.env.HAS_SMS,

      showTruckDetail: false,
      canSeeFilters: false,
      canEditTruck: false,
      canAddTruck: false,
      showDelete: false,

      objects: [],
      filters: {},
      trucks: [],
      line: [],

      timer: undefined,
      truckId: null,

      pageSize: 10,
      date: ''
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  computed: {
    ...mapState({
      companyId: state => state.auth.company,
      userData: state => state.auth.userData,
      kioskId: state => state.auth.kiosk.id,
      count: state => state.trucks.count,
      user: state => state.auth.user
    }),
    pagesShown: {
      get: function () {
        var pages = [this.page]
        for (let index = 1; index <= 2; index++) {
          if (this.page - index > 0) pages.push(this.page - index)
          if (this.page + index <= Math.ceil(this.count / this.pageSize)) pages.push(this.page + index)
        }
        return pages.sort(function (a, b) { return a - b })
      }
    }
  },
  watch: {
    companyId (newVal) {
      if (newVal) {
        this.getCompany({ id: newVal }).then(response => {
          this.isTrw = response[0].is_trw
        })
      }
    }
  },
  methods: {
    ...mapActions({
      hasPermissions: 'auth/hasPermissions',
      deleteObject: 'trucks/delete',
      getCompany: 'listes/company',
      getObjects: 'trucks/list'
    }),
    deleteLine (line) {
      console.log('Deleting line:', line)
      this.deleteObject(line.id).then(() => {
        console.log('Line deleted')
        this.fillPage(this.page)
        this.showDelete = false
      }).catch((e) => {
        console.error('Error deleting line', e)
      })
    },
    fillPage (page) {
      var filters = Object.assign({}, {page: page, page_size: this.pageSize}, this.filters)
      this.filters = filters
      this.getPage(page)
    },
    refreshTable () {
      this.$nextTick(() => {
        this.timer = setInterval(() => {
          // eslint-disable-next-line
          if (this.$route.name != 'trucks') clearInterval(this.timer)
          else if (this.userData.roles && this.userData.roles.map((x) => { return x.id }).indexOf(this.kioskId) > -1) {
            if (this.page + 1 <= Math.ceil(this.count / this.pageSize)) this.fillPage(++this.page)
            else this.$emit('next')
          }
        }, (process.env.REFRESH_TIME * 1000))
      })
    },
    openTruckDetail (truck) {
      if (truck) this.truckId = truck.id
      this.showTruckDetail = true
    },
    handleTruckSave () {
      this.showTruckDetail = false
      this.fillPage(this.page)
    },

    // Async methods
    async getPermissions () {
      const permissionResponse = await this.hasPermissions(['addTruck', 'seeFilters', 'editTruck'])
      this.canAddTruck = permissionResponse.addTruck
      this.canSeeFilters = permissionResponse.seeFilters
      this.canEditTruck = permissionResponse.editTruck
    },
    async checkCompany () {
      if (this.companyId) {
        const companyResponse = await this.getCompany({ id: this.companyId })
        this.isTrw = companyResponse && companyResponse.length > 0 ? companyResponse[0].is_trw : this.isTrw
      }
    },
    async getTrucksData () {
      try {
        this.fillPage(this.page)
        await this.checkCompany()
        await this.getPermissions()
      } catch (error) {
        console.error('Error getting trucks:', error)
      } finally {
        this.$emit('loaded')
      }
    }
  }
}
</script>

<style scoped lang="scss">
#trucks {
  display: table;
}
.title {
  a {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PageTruck.vue